import {
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RoutineAllColumn } from './asset-routines-all-column';
import { AssetRoutinesHeader } from './asset-routines-header';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetRoutines = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();

  if (!assetId) {
    return null;
  }

  const leftColumn = (
    {
      title: 'assets.menu.title',
      mainComponent: (
        <AssetCard assetId={assetId} />
      ),
      showBackButton: true,
      headerComponent: (
        <AssetFilters 
          assetId={assetId}
        />
      ),
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => {
        navigate(`/assets/${assetId}`);
      },
      disableScroll: true
    }
  );

  const rightColumn = (
    {
      title: 'asset.header.buttons.routines',
      mainComponent: (<RoutineAllColumn assetId={assetId} />),
      headerComponent: (
        <AssetRoutinesHeader assetId={assetId} />
      ),
      showBackButton: true,
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => {
        navigate(`/assets/${assetId}/routines/all`);
      },
      disableScroll: true
    }
  );

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
